import { Card, CardContent } from "@/shared/components/ui/card";
import { Button } from "@/shared/components/ui/button";
import { Link } from "react-router-dom";
import { POST_LOSS_ROUTES } from "@/shared/constants/paths";

interface BlogCTAProps {
  subhead?: string;
  urlParameter?: string;
}

export default function BlogCTA({ subhead, urlParameter }: BlogCTAProps) {
  // Extract task ID from URL parameter (e.g., "?task=41&" -> "41")
  const extractTaskId = (param?: string): string | null => {
    if (!param) return null;
    const match = param.match(/task=(\d+)/);
    return match ? match[1] : null;
  };

  const taskId = extractTaskId(urlParameter);
  // Note: task-specific routes are no longer supported — point to overview regardless
  void taskId;
  const actionCenterUrl = POST_LOSS_ROUTES.OVERVIEW;

  return (
    <Card className="border-0 bg-gradient-to-r from-teal-600 to-teal-500 rounded-xl shadow-sm my-8">
      <CardContent className="p-6">
        <div className="flex items-center justify-between gap-4">
          {/* Left side - Dynamic content */}
          <div className="flex-1">
            <h2 className="font-medium text-white max-w-md">
              {subhead || "Have Elayne do this for me"}
            </h2>
          </div>

          {/* Right side - Button */}
          <Link to={actionCenterUrl}>
            <Button
              variant="default"
              className="bg-white text-teal-700 hover:bg-stone-50 font-semibold"
            >
              Go to my roadmap
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
